import type { Distance, Pixel } from "@pdfking/math"

import type { Matrix } from "#public"

import { ToPixels } from "./ToPixels"

/** A transform written in the plot's own units, in the backend's pixels.
 *
 * Only the translation converts: `a`–`d` are ratios and mean the same thing in
 * either space. A backend needs this before composing with anything it measured
 * itself, and every one of them emits pixels in the end. */
export const MatrixToPixels = (
  context: { unit_to_px: Pixel },
  [a, b, c, d, e, f]: Matrix<Distance>
): Matrix<Pixel> => [a, b, c, d, ToPixels(context, e), ToPixels(context, f)]
